import { Container } from '@algbra/ui/components/Grid/Grid'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { useEffect, useRef } from 'react'
import ContentBox from '../../components/ContentBox/ContentBox'

export type ZoneEmbedScriptProps = {
  __typename: 'StrapiGQL_ComponentZonesEmbedScript'
  id: string
  title: string
  src?: string
}

export default function ZoneEmbedScript(props: ZoneEmbedScriptProps) {
  const { src } = props
  const scriptPlaceholder = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (src) {
      const script = document.createElement('script')
      script.async = true
      script.id = 'CookieDeclaration'
      script.src = src
      scriptPlaceholder.current.appendChild(script)
    }
  })

  return (
    <Whitespace type="none">
      <ContentBox size="small">
        <Container>
          <div ref={scriptPlaceholder} />
        </Container>
      </ContentBox>
    </Whitespace>
  )
}
